// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--Si_n-","Empty":"Empty--23J2C"};